// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PostEngagementFollowPrompt-cls1___318b58dd660c6dba4b6{/*!*/}.PostEngagementFollowPrompt-cls2___dfd95f9c383a9ddfa2b{}.PostEngagementFollowPrompt-cls2___dfd95f9c383a9ddfa2b:disabled{background-color:#dddde2;color:#535366;cursor:default}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PostEngagementFollowPrompt-cls1___318b58dd660c6dba4b6",
	"cls2": "PostEngagementFollowPrompt-cls2___dfd95f9c383a9ddfa2b PostEngagementFollowPrompt-cls1___318b58dd660c6dba4b6"
};
export default ___CSS_LOADER_EXPORT___;
